export default __webpack_public_path__ + "static/media/spicycupcake@3x.d05c522f.jpg";